import { useTheme, Box, TextV2 } from '@withjoy/joykit';
import React, { useEffect, useState } from 'react';
import { StyledProgressRing, StyledIconWrapper, StyledProgressRingWrapper, styles, StyledSvg, StyledCheckFilled } from './styles';
import { ReactComponent as Checkmark } from '../../assets/thick-check.svg';
import { ProgressRingProps } from './types';

const PROGRESS_RING_DIMENSIONS = {
  width: 48,
  height: 48,
  cx: 24,
  cy: 24,
  r: 22,
  strokeWidth: 4
};

export const ProgressRing = ({ progressPercent, isOpen, currentGiftCount }: ProgressRingProps) => {
  const { colors } = useTheme();
  const [progress, setProgress] = useState<number | undefined>(undefined);

  const { width, height, cx, cy, r, strokeWidth } = PROGRESS_RING_DIMENSIONS;
  const circumference = r * 2 * Math.PI;

  useEffect(() => {
    const progress = (() => {
      if (progressPercent / 100 >= 1) {
        return 1;
      } else {
        return circumference - (progressPercent / 100) * circumference;
      }
    })();

    if (!isOpen) {
      setProgress(undefined);
      return;
    }
    const timer = setTimeout(() => {
      setProgress(progress);
    }, 500);
    return () => clearTimeout(timer);
  }, [circumference, progressPercent, isOpen]);

  return (
    <StyledProgressRingWrapper __css={styles.progressRingWrapper} dimensions={PROGRESS_RING_DIMENSIONS}>
      <Box position="relative">
        <StyledSvg viewBox={`0 0 ${width} ${height}`} dimensions={PROGRESS_RING_DIMENSIONS}>
          <StyledProgressRing dashoffset={circumference} strokeWidth={strokeWidth} stroke={colors.mono4} strokeLinecap="round" cx={cx} cy={cy} r={r} />
          <StyledProgressRing
            strokeWidth={strokeWidth}
            stroke={colors.mono14}
            strokeDasharray={`${circumference} ${circumference}`}
            dashoffset={circumference}
            progress={progress}
            strokeLinecap="round"
            cx={cx}
            cy={cy}
            r={r}
          />
        </StyledSvg>
        {progressPercent >= 100 && <StyledCheckFilled color="mono14" size="sm" __css={styles.checkFilled} />}
      </Box>
      <StyledIconWrapper __css={styles.iconWrapper}>
        {progress === 100 ? <Checkmark /> : <TextV2 typographyVariant={currentGiftCount > 999 ? 'hed1' : 'hed3'}>{currentGiftCount}</TextV2>}
      </StyledIconWrapper>
    </StyledProgressRingWrapper>
  );
};
